// extracted by mini-css-extract-plugin
export default {"Box":"layout-selector-module__Box--p7dwj"};